export default __webpack_public_path__ + "static/media/daily-pause-stat-tile-balloon.ac8c0c6a.svg";